import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';
import { Menu, NavService } from '../../services/nav.service';
import { SearchService } from '../../services/search.service';
import { CommonSvgIconsComponent } from '../common-svg-icons/common-svg-icons.component';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { SvgIconsComponent } from '../svg-icons/svg-icons.component';
import {AuthService} from "../../../core/services/auth.service";

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonSvgIconsComponent, FeatherIconsComponent, CommonModule,
    SvgIconsComponent, TranslateModule, FormsModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})

export class SidebarComponent {

  public leftArrow: boolean = false;
  public rightArrow: boolean = true;
  public search_text: string = '';
  public width: number = window.innerWidth;
  public pinnedDataList: string[] = [];
  public menuItemsListAll = this.navService.MENUITEMSALL;
  public menuItemsList = this.navService.MENUITEMS;
  public pinnedData: boolean = false;
  public itemsData: Menu[] = [];
  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public text: string;

  userLogged: any = {};

  constructor(public navService: NavService,
    private router: Router,
    public layoutServices: LayoutService,
    public searchServices: SearchService,
              private auth:AuthService
  ) {
    this.userLogged = this.auth.getUser();

    this.navService.items.subscribe((data) => {
      let permissions = this.auth.getPermissions() ?? [];
      let stringItems = JSON.stringify(this.menuItemsListAll);
      let arrayTemp = JSON.parse(stringItems);
      // Función para filtrar dataAll
      this.menuItemsList = arrayTemp.filter((item: any) => {
        // Dinámicamente asignar el título de Logística vs Cotizar
        if (item.title === 'Cotizar/Reservar' || item.title === 'Logística') {
          if (permissions.includes('rol_client') && !permissions.includes('Lista')) {
            item.title = 'Cotizar/Reservar';
          } else {
            item.title = 'Logística';
          }
        }

        // Si el item tiene 'children', se filtran los hijos primero
        if (item.children) {
          // Filtramos los hijos por su módulo o por la existencia de un módulo permitido
          item.children = item.children.filter((child: any) =>
              child.module && permissions.includes(child.module) || !child.module
          );
          // Si después de filtrar los hijos hay algún hijo permitido, mantenemos el item
          if (item.children.length > 0) {
            return true;
          }
          // Si no hay hijos permitidos, lo eliminamos
          return false;
        }

        // Filtramos el item principal por su módulo
        return permissions.includes(item.module);
      });
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.menuItemsList.filter((items: any) => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) {
              return false;
            }
            items.children.filter((subItems: any) => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) {
                return false;
              }
              subItems.children.filter((subSubItems: any) => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
              return;
            });
            return;
          });
        }
      });
    });
  }

  isPined(itemName: string | undefined): boolean {
    return itemName !== undefined && this.pinnedDataList?.includes(itemName);
  }

  pinned(title: string) {
    const index = this.pinnedDataList.indexOf(title);
    if (index !== -1) {
      this.pinnedDataList.splice(index, 1);
    } else {
      this.pinnedDataList.push(title);
    }
    if (this.pinnedDataList.length <= 0) {
      this.pinnedData = false;
    } else {
      this.pinnedData = true;
    }
  }

  toggleNavActive(item: Menu) {
    if (!item.active) {
      this.menuItemsList.forEach((a: Menu) => {
        if (this.menuItemsList.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b: Menu) => {
          if (a.children?.includes(item)) {
            b.active = false;
          }
        });
        return;
      });
    }
    item.active = !item.active;
  }

  setNavActive(item: Menu) {
    this.menuItemsList.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter((submenuItems: any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          } else {
            submenuItems.active = false;
          }
        });
      }
    });
  }

  closeMenu() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  scrollToLeft() {
    this.rightArrow = true;
    if (this.layoutServices.margin != 0) {
      this.layoutServices.margin = this.layoutServices.margin + 500;
    }

    if (this.layoutServices.margin == 0) {
      this.leftArrow = false;
    }
  }

  scrollToRight() {
    this.leftArrow = true;
    if (this.layoutServices.margin != -3500) {
      this.layoutServices.margin = this.layoutServices.margin - 500;
    }
    if (this.layoutServices.margin == -3500) {
      this.rightArrow = false;
    }
  }
}
